// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import TokenService from '@/services/auth/TokenService'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import store from '@/store/index'
import jwtInterceptor from '@/services/api/jwtInterceptor'
import '@/plugins/v-currency-field.js'

Vue.config.productionTip = false

jwtInterceptor(store)

router.beforeEach((to, from, next) => {
  const publicPages = ['/Login']
  const authRequired = !publicPages.includes(to.path)
  const login = TokenService.getLogin()

  if (to.name === 'LinkLogin') {
    next()
    return
  }

  if (authRequired && (!login || !store.getters['authentication/isLoggedIn'])) {
    TokenService.removeLogin()
    store.commit('authentication/LOGOUT')
    next('/Login')
  } else {
    console.log('NEXT ' + from.path + ' -> ' + to.path)
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js